<template>
    <div>
        <b-row>
            <b-col sm="8">
                <h5 class="heading-1 mb-4">
                    <span>Comprometimento</span>
                </h5>
            </b-col>
            <b-col sm="4">
                <b-button
                    class="float-right"
                    variant="warning"
                    @click="voltarComprometimentos()"
                    ><i class="fa fa-history"></i> Voltar aos
                    comprometimentos</b-button
                >
                <btn-comprometer
                    v-if="
                        comprometimento.status == 1 &&
                            $temAcessoView('CONT-COMPR-01')
                    "
                    class="float-right mr-2"
                    :contrato="contrato"
                    :comprometimento="comprometimento"
                    @atualizarComprometimento="
                        $emit('atualizarComprometimento', $event)
                    "
                    @atualizarErros="erros = $event"
                    :operacao="operacao"
                ></btn-comprometer>
                <btn-descomprometer
                    :contrato="contrato"
                    :comprometimento="comprometimento"
                    @atualizarComprometimento="
                        $emit('atualizarComprometimento', $event)
                    "
                    @atualizarErros="erros = $event"
                    class="float-right mr-2"
                    v-if="
                        comprometimento.status == 4 &&
                            $temAcessoView('CONT-COMPR-03')
                    "
                >
                </btn-descomprometer>
            </b-col>
        </b-row>
        <b-alert variant="warning" show v-if="!comprometimento.saldoNaturezaOk"
            ><i class="fa fa-exclamation-triangle fa-lg"></i
            ><strong>
                O saldo da natureza de despesa do contrato é menor que o valor
                do comprometimento</strong
            ></b-alert
        >
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-alert show>
            <b-row>
                <b-col>
                    Id:
                    <strong>{{ comprometimento.chaveOrigem }}</strong
                    ><br />
                    Histórico:
                    <strong>{{ comprometimento.vcHistorico }}</strong
                    ><br />
                    Data Emissão :
                    <strong>{{
                        $moment(comprometimento.dtEmissao).format('DD/MM/YYYY')
                    }}</strong
                    ><br />
                    Data Movimento:
                    <strong>{{
                        $moment(comprometimento.dtEmissao).format('DD/MM/YYYY')
                    }}</strong
                    ><br />
                    Valor:
                    <strong>{{
                        comprometimento.nuValorComprometimento | currency
                    }}</strong
                    ><br />
                    Id RM: <strong>{{ comprometimento.idRm }}</strong
                    ><br />
                    Status:
                    <app-status
                        :status="comprometimento.statusDescr"
                    ></app-status>
                </b-col>
            </b-row>
        </b-alert>

        <b-row>
            <b-col :sm="comprometimento.status == 1 ? 8 : 12">
                <h5 class="heading-1 mb-4">
                    <span>Rateios</span>
                </h5>
            </b-col>
            <b-col
                sm="4"
                v-if="
                    $temAcessoView('CONT-COMPR-02') &&
                        comprometimento.status == 1
                "
            >
                <b-button
                    variant="primary"
                    class="float-right"
                    @click="operacao = 'C'"
                    v-if="operacao == 'D'"
                    ><i class="fa fa-edit"></i> Atualizar Rateios</b-button
                >
                <b-button
                    class="float-right"
                    variant="primary"
                    v-if="operacao != 'D'"
                    :disabled="desabilitarSalvar"
                    @click.stop="confirmarSalvar()"
                    ><i class="fa fa-floppy-o"></i> Salvar</b-button
                >
                <b-button
                    class="float-right mr-2"
                    variant="danger"
                    v-if="operacao != 'D'"
                    @click="cancelar()"
                    ><i class="fa fa-times-circle-o"></i> Cancelar</b-button
                >
                <btn-inserir-dotacao
                    class="float-right mr-2"
                    :tipo="operacao"
                    v-if="operacao != 'D'"
                    :valorTotal="valorASerRateado"
                    :valorDisponivel="valorDisponivel"
                    @inserirRateio="inserirRateio($event)"
                ></btn-inserir-dotacao>
            </b-col>
        </b-row>
        <b-row v-if="operacao != 'D'">
            <b-col>
                <app-box titulo="Total a ser rateado">{{
                    valorASerRateado | currency
                }}</app-box>
            </b-col>
            <b-col>
                <app-box
                    titulo="Total rateado"
                    :corBox="corBox"
                    :corTexto="corTexto"
                    >{{ valorRateado | currency }} |
                    {{
                        percentualRateado
                            | currency({
                                symbol: '%',
                                thousandsSeparator: '.',
                                fractionCount: 2,
                                fractionSeparator: ',',
                                symbolPosition: 'back',
                                symbolSpacing: false
                            })
                    }}</app-box
                >
            </b-col>
            <b-col>
                <app-box
                    titulo="Total disponível para ratear"
                    :corBox="corBox"
                    :corTexto="corTexto"
                    >{{ valorDisponivel | currency }}</app-box
                >
            </b-col>
        </b-row>
        <rateios-tabela
            :rateios="rateios"
            :temAcoes="operacao != 'D'"
            :valorASerRateado="valorASerRateado"
            :valorDisponivel="valorDisponivel"
            :operacao="operacao"
            @atualizarRateio="atualizarRateio($event)"
            @excluirRateio="excluirRateio($event)"
        >
            <template slot="botoes"> </template>
        </rateios-tabela>
    </div>
</template>

<script>
import RateiosTabela from './RateiosTabela'
import BtnInserirDotacao from './BtnInserirDotacao'
import BtnComprometer from './../BtnComprometer'
import BtnDescomprometer from './../BtnDescomprometer'
import ComprometimentosServicos from './../ComprometimentosServicos'

export default {
    components: {
        RateiosTabela,
        BtnInserirDotacao,
        BtnComprometer,
        BtnDescomprometer
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        },

        comprometimento: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            operacao: 'D',
            rateios: [],
            erros: []
        }
    },

    methods: {
        cancelar() {
            this.operacao = 'D'
            this.resetarRateios()
        },

        voltarComprometimentos() {
            this.operacao = 'D'
            this.$emit('atualizarComprometimento', null)
        },

        resetarRateios() {
            if (this.comprometimento) {
                this.rateios = JSON.parse(
                    JSON.stringify(this.comprometimento.rateios)
                )
            }
        },

        inserirRateio(rateio) {
            if (
                this.rateios.filter(r => {
                    return (
                        r.codUnidade == rateio.codUnidade &&
                        r.codProjeto == rateio.codProjeto &&
                        r.codAcao == rateio.codAcao
                    )
                }).length > 0
            ) {
                this.erroNaInclusaoDotacao()
            } else {
                this.rateios.push(rateio)
            }
        },

        erroNaInclusaoDotacao() {
            this.$swal({
                title: 'Dotação Orçamentária',
                html: `Já existe dotação com a unidade/projeto/ação informados`,
                icon: 'error'
            })
        },

        atualizarRateio(rateio) {
            for (let index = 0; index < this.rateios.length; index++) {
                const rateioAtual = this.rateios[index]
                if (
                    rateioAtual.codUnidade == rateio.codUnidade &&
                    rateioAtual.codProjeto == rateio.codProjeto &&
                    rateioAtual.codAcao == rateio.codAcao
                ) {
                    this.rateios[index].nuValorRateio = rateio.nuValorRateio
                    // this.rateios[index].percentual =
                    //     rateio.percentual
                    // this.rateios[index].justificativa =
                    //     rateio.justificativa
                    // this.rateios[
                    //     index
                    // ].dataAtualizacao = new Date()
                    break
                }
            }
        },

        excluirRateio(rateio) {
            for (let index = 0; index < this.rateios.length; index++) {
                const rateioAtual = this.rateios[index]
                if (
                    rateioAtual.codUnidade == rateio.codUnidade &&
                    rateioAtual.codProjeto == rateio.codProjeto &&
                    rateioAtual.codAcao == rateio.codAcao
                ) {
                    this.rateios.splice(index, 1)
                    break
                }
            }
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Rateios',
                html: `Confirma as alterações no rateio?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarRateios()
                }
            })
        },

        salvarRateios() {
            this.$store.dispatch('addRequest')
            let comprometimentoRateios = {
                idContrato: this.contrato.idContrato,
                idComprometimentoRequisicao: this.comprometimento
                    .idComprometimentoRequisicao,
                rateios: this.rateios
            }
            ComprometimentosServicos.salvarRateios(comprometimentoRateios).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Rateios atualizados com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit(
                                'atualizarComprometimento',
                                response.data
                            )
                            this.operacao = 'D'
                        } else {
                            this.$toast.error(
                                'Falha ao atualizar rateios!',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    computed: {
        desabilitarSalvar() {
            return (
                this.valorDisponivel > 0 ||
                JSON.stringify(this.rateios) ==
                    JSON.stringify(this.comprometimento.rateios)
            )
        },

        valorASerRateado() {
            return this.comprometimento.nuValorComprometimento
        },

        valorRateado() {
            return Number.parseFloat(
                this.rateios
                    .map(item => {
                        return item.nuValorRateio
                    })
                    .reduce((a, b) => a + b, 0)
                    .toFixed(2)
            )
        },

        valorDisponivel() {
            return Number.parseFloat(
                (this.valorASerRateado - this.valorRateado).toFixed(2)
            )
        },

        percentualRateado() {
            return (this.valorRateado / this.valorASerRateado) * 100
        },

        corTexto() {
            return this.percentualRateado < 100 ? 'danger' : 'primary'
        },

        corBox() {
            return this.percentualRateado < 100 ? 'danger' : 'primary'
        }
    },

    watch: {
        comprometimento() {
            this.resetarRateios()
        }
    },

    mounted() {
        this.resetarRateios()
    }
}
</script>
